import React from 'react'
import Smartview from 'widgets/smartviews/Smartview'
import { Translation, Translator } from '@morningtrain/react-translations'
import {
  ExecuteOperationOnPipe,
  ModelWithForm,
  TriggerPipelineOnFormSubmit,
  useValue
} from '@morningtrain/react-resources'
import * as Fields from 'support/fields'
import { ResourceSelector } from 'support/fields'
import { Fieldset } from 'layouts/index'
import SmartviewContentSection from 'widgets/smartviews/partials/SmartviewContentSection'
import AssignBadgeSmartviewFooter from 'widgets/smartviews/settings/AssignBadgeSmartviewFooter'
import { Pipeline } from '@morningtrain/react-helpers'

export default function AssignBadgeSmartview () {
  const id = useValue('id')

  return (
    <Translator namespace='settings.badges.smartviews.assign_badge'>
      <ModelWithForm resourceName='badges.badges' id={id}>
        <Smartview header={<Translation name='title' />} footer={<AssignBadgeSmartviewFooter />}>
          <SmartviewContentSection>
            <Fieldset>
              <Fields.Select
                enum='badges'
                name='badge'
              />
              <ResourceSelector
                name='user_id'
                optionsKey='name'
                resourceName='users.users'
                operationName='select'
                label={<Translation name='fields.user.label' />}
              />
              <Fields.Date
                name='active_at'
                label={<Translation name='fields.active_at.label' />}
              />
              <Fields.Date
                name='end_at'
                label={<Translation name='fields.end_at.label' />}
              />
            </Fieldset>
          </SmartviewContentSection>
          <Pipeline>
            <TriggerPipelineOnFormSubmit />
            <ExecuteOperationOnPipe operationName='index' />
          </Pipeline>
        </Smartview>
      </ModelWithForm>
    </Translator>
  )
}
